module.exports = __webpack_public_path__ + "2f4a54eb78084b828cbfac017cefe54e.svg";